import { useEffect } from "react";
import OrgUserView from "../components/OrgUserView";
import { useAppContext } from "../hooks/useAppContext";
import { useLazyGetOrgUserByOrganizationIdAndOrgUserId } from "../operations/queries/getOrgUserByOrganizationIdAndOrgUserId";

interface Props {
  orgUserId?: string;
  onClose: () => void;
}

const OrgUserViewContainer = ({ orgUserId, onClose }: Props) => {
  const { currentOrganization } = useAppContext();

  const { getOrgUserByOrganizationIdAndOrgUserId, data } =
    useLazyGetOrgUserByOrganizationIdAndOrgUserId();

  useEffect(() => {
    if (orgUserId && currentOrganization) {
      getOrgUserByOrganizationIdAndOrgUserId({
        variables: { organizationId: currentOrganization.id, orgUserId },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUserId]);

  return (
    <OrgUserView
      orgUser={data?.orgUserByOrganizationIdAndOrgUserId}
      onClose={onClose}
    />
  );
};

export default OrgUserViewContainer;
